import { render, staticRenderFns } from "./dynamicControl.vue?vue&type=template&id=38e79e16&scoped=true"
import script from "./dynamicControl.vue?vue&type=script&lang=js"
export * from "./dynamicControl.vue?vue&type=script&lang=js"
import style0 from "./dynamicControl.vue?vue&type=style&index=0&id=38e79e16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e79e16",
  null
  
)

export default component.exports